import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import CustomPlugin from './CustomPlugin';
import VueFinder from 'vuefinder_fix/dist/vuefinder'
import 'vuefinder_fix/dist/style.css'
import VueFeather from 'vue-feather';
import simplebar from 'simplebar-vue';

export function configurePlugins(app) {
  app.use(PrimeVue)
     .use(ToastService)
     .use(ConfirmationService)
     .use(CustomPlugin)
     .use(VueFinder)
      .component(VueFeather.name, VueFeather)
      .component('simplebar', simplebar);
}